<template>
  <span>{{ wallet.point | balanceValue }}</span>
</template>

<script>
import WalletBalance from './wallet-balance';

export default {
  name  : 'PointBalance',
  mixins: [WalletBalance],
};
</script>
